import { applicationModuleRegistry } from '@philips-internal/oswald-ui-foundation';
import { APPLICATION_ROUTES } from '../../constants/application-routes';

export function setupExams(): void {

  applicationModuleRegistry.register({
    entry: 'exam-results',
    id: 'exam-results',
    name: 'result.exam-results.title',
    route: APPLICATION_ROUTES.EXAMS_RESULTS
  });

}